// extracted by mini-css-extract-plugin
module.exports = {"status":"ExemptionLimitsModal_status__5Jm5U","green":"ExemptionLimitsModal_green__HGUMY","red":"ExemptionLimitsModal_red__qA454"};